export default "__VITE_PUBLIC_ASSET__1ded820b__"